import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const babyFollowingWhen: BlogMetaData = {
  title: '赤ちゃんの後追いはいつから始まる？月齢の目安と今日からできる関わり方',
  description:
    '赤ちゃんの後追いはいつから始まるのか、月齢の目安と個人差の考え方を解説。ハイハイ・分離不安との関係、対象物の永続性というモンテッソーリの視点、家庭でできる関わり方まで、今日から実践できる形でまとめました。',
  thumbnailUrl: '/img/blog-baby-following-when.webp',
  filePath: buildBlogFilePath('baby-following-when'),
  category: BLOG_CATEGORY.PARENTING,
};
